import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=ed0b5bdc&scoped=true&"
import script from "./accordion.vue?vue&type=script&lang=js&"
export * from "./accordion.vue?vue&type=script&lang=js&"
import style0 from "./accordion.vue?vue&type=style&index=0&id=ed0b5bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0b5bdc",
  null
  
)

component.options.__file = "accordion.vue"
export default component.exports